import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { ClearAllFiltersButton } from '@/core/ClearAllFiltersButton';

interface SearchResultsProps {
  isLoading: boolean;
  onClear: () => void;
  searchString: React.ReactNode;
  extraClassNames?: string;
}

export const SearchResults = ({ isLoading, onClear, searchString, extraClassNames }: SearchResultsProps) => {
  const { t } = useTranslation();

  return (
    <div className={clsx('width-maximum', 'flexRowContainer', extraClassNames)}>
      <h4>{t('SEARCH_DATA.SEARCH_RESULTS')}</h4>
      {!isLoading && (
        <div className="specActiveFilters tw:mb-sq-10 tw:italic">
          {searchString}
          <ClearAllFiltersButton onClear={onClear} />
        </div>
      )}
    </div>
  );
};
